export default __webpack_public_path__ + "static/media/swimming.9721da09.svg";